import { Injectable } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private DEBOUNCE_TIME = this.configService.config?.loading.debounceTime;
  private MINIMUM_LOADING_TIME = this.configService.config?.loading.minimumLoadingTime;
  private loadingStartTime: number | null = null;

  // Add debounce to prevent quick flashes
  loading$ = this.loadingSubject.pipe(
    debounceTime(this.DEBOUNCE_TIME!),
    distinctUntilChanged()
  );

  constructor(private configService: ConfigService) {}

  setLoading(loading: boolean) {
    if (loading) {
      this.loadingStartTime = Date.now();
      this.loadingSubject.next(true);
    } else if (this.loadingStartTime) {
      const elapsedTime = Date.now() - this.loadingStartTime;
      const remainingTime = Math.max(
        0,
        this.MINIMUM_LOADING_TIME! - elapsedTime
      );

      // Ensure minimum display time
      timer(remainingTime).subscribe(() => {
        this.loadingStartTime = null;
        this.loadingSubject.next(false);
      });
    }
  }
}
